module.exports = __webpack_public_path__ + "static/columnMoving-705b4cece2d0636fa40004bc0a821a1b.gif";